import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../lib/axiosInstance';

export const RRS_API = '/stock/rrs';
export function useGenerateRRFromPO() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) =>
      await axiosInstance.post(`${RRS_API}/generateRR/${id}`),
    onSuccess: () => {
      return queryClient.refetchQueries();
    },
  });
}

export function useUploadRRFiles() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: { id: string; formData: FormData }) => {
      return await axiosInstance.putForm(
        `${RRS_API}/${data.id}/upload`,
        data.formData,
      );
    },
    onSuccess: () => {
      return queryClient.refetchQueries();
    },
  });
}

export function useDeleteRRFile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      return await axiosInstance.delete(`${RRS_API}/files?ids=${id}`);
    },
    onSuccess: () => {
      return queryClient.refetchQueries();
    },
  });
}
